// extracted by mini-css-extract-plugin
export default {"root":"ConsumptionTable_root__uW9RA","table":"ConsumptionTable_table__kBxi5","downloadButton":"ConsumptionTable_downloadButton__Nmec3","button":"ConsumptionTable_button__22S1o"};